import * as Types from '../../../gql.generated';

import gql from 'graphql-tag';
export type ChangeTrackingFragmentFragment = (
  { __typename?: 'ProvingChangeTracking' }
  & Pick<Types.ProvingChangeTracking, 'changed' | 'changeType'>
  & { rootChange: Types.Maybe<(
    { __typename?: 'ProvingChange' }
    & Pick<Types.ProvingChange, '_id' | 'provingId' | 'status' | 'created' | 'resolved'>
    & { change: (
      { __typename?: 'ProvingChangeDetails' }
      & Pick<Types.ProvingChangeDetails, 'key' | 'type' | 'path' | 'value' | 'valueType' | 'oldValue' | 'relativePath'>
    ), createdBy: (
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'name'>
    ), resolvedBy: Types.Maybe<(
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'name'>
    )> }
  )>, changes: Types.Maybe<Array<(
    { __typename?: 'ProvingChange' }
    & Pick<Types.ProvingChange, '_id' | 'provingId' | 'status' | 'created' | 'resolved'>
    & { change: (
      { __typename?: 'ProvingChangeDetails' }
      & Pick<Types.ProvingChangeDetails, 'key' | 'type' | 'path' | 'value' | 'valueType' | 'oldValue' | 'relativePath'>
    ), createdBy: (
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'name'>
    ), resolvedBy: Types.Maybe<(
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'name'>
    )> }
  )>> }
);
export const ChangeTrackingFragmentFragmentDoc = gql`
    fragment ChangeTrackingFragment on ProvingChangeTracking {
  changed
  changeType
  rootChange {
    _id
    provingId
    status
    change {
      key
      type
      path
      value
      valueType
      oldValue
      relativePath
    }
    created
    createdBy {
      _id
      name
    }
    resolved
    resolvedBy {
      _id
      name
    }
  }
  changes {
    _id
    provingId
    status
    change {
      key
      type
      path
      value
      valueType
      oldValue
      relativePath
    }
    created
    createdBy {
      _id
      name
    }
    resolved
    resolvedBy {
      _id
      name
    }
  }
}
    `;